import React, { Fragment } from "react";
import LeyendaIntensidades from "./LeyendaIntensidades";
import MapaIntensidades from "./MapaIntensidades";

const ResMapa = ({resumen, idSismo})=> {
    return (
        <Fragment>
            <div className="ResultadosContenedorH" style ={{width:"100%", maxWidth:"100vw", height:"100%"}}>
                <div style={{flexGrow: 2, minHeight:"400px", height:"100%", backgroundColor:"#aa45ef"}}>
                    <MapaIntensidades
                    mostrarCoordenadas={true}
                    resumenSismo={resumen}
                    idSismo={idSismo}/>
                </div>
                <div style={{flexGrow: 1, display:"flex", flexDirection: "column", width:"300px"}}>
                    <div><LeyendaIntensidades mostrarTooltips={true}/></div>
                    <div style={{border: "2px black solid", padding: "5px", textAlign: "justify", marginTop:"10px"}} >
                    El mapa de intensidad s&iacute;smica en la escala EMS-98 (escala macros&iacute;smica europea) hace referencia a la distribuci&oacute;n y severidad con la que se sinti&oacute; el sismo teniendo en cuenta los efectos reportados por la poblaci&oacute;n 
                    a trav&eacute;s del formulario para la evaluaci&oacute;n de intensidades en diferentes municipios. El pin indica el epicentro instrumental del sismo y los c&iacute;rculos de colores se refieren a la intensidad asociada
                    a cada municipio.
                    </div>
                </div>
            </div>

            <div style={{backgroundColor: "#DDDDDD", color: "#888888", fontSize: "15px"}}>
                <b>Aviso legal:</b> Los puntos de intensidad que se muestran en el mapa se determinan teniendo en cuenta todos los formularios diligenciados por la comunidad. Los datos recogidos son sometidos a un filtro autom&aacute;tico de tipo estad&iacute;stico, pero no se comprueban de forma individual. 
                Se considera que a partir de intensidad mayor o igual a 6 en la escala EMS-98 se necesita una verificaci&oacute;n en el sitio por personal capacitado. El SGC no es responsable del uso indebido de la informaci&oacute;n proporcionada en este sitio web.
            </div>
        </Fragment>  
    )
}

export default ResMapa;